// import axios from 'axios'
import VuexReset from '@ianwalter/vuex-reset'
import { createStore } from 'vuex'

export default createStore({
  plugins: [VuexReset()],
  state: {
    host:import.meta.env.VITE_APP_HOST,
    port:import.meta.env.VITE_APP_PORT_WEBSOCKET,
    api:import.meta.env.VITE_APP_API_URL,
    apifile:import.meta.env.VITE_APP_API_FILE,
    linkMail:import.meta.env.VITE_APP_LINK_MAIL,
    yearCommande:0,
    dataAccueil: [],
    factures: [],
    factureValide: [],
    facturesEnCoursLivraison: [],
    facturesEnCoursRecuperation:[],
    nbrEnCourLivraisonCommande:0,
    nbrEnCourRecuperationCommande:0,
    nbrAnnuleCommande:0,
    nbrValideCommande:0,
    facturesAnnule: [],
    notifications: [],
    notificationsnonlu: 0,
    routerLastPosition: {},
    loadedArticleImages: {},
    facturesExpirantes: [],
    facturesLivraisonVendeurExpirantes: [],
  },
  getters: {

  },
  mutations: {
    reset() {

    },
    
    ajouterFactureExpirante(state, facture) {
        if (!state.facturesExpirantes.find(f => f.id === facture.id)) {
            state.facturesExpirantes.push(facture)
        }
    },
    ajouterFactureLivraisonVendeurExpirante(state, facture) {
        if (!state.facturesLivraisonVendeurExpirantes.find(f => f.id === facture.id)) {
            state.facturesLivraisonVendeurExpirantes.push(facture)
        }
    },
    retirerFactureExpirante(state, factureId) {
        state.facturesExpirantes = state.facturesExpirantes.filter(f => f.id !== factureId)
        state.facturesLivraisonVendeurExpirantes = state.facturesLivraisonVendeurExpirantes.filter(f => f.id !== factureId)
    },

    REQUEST_ROUTER_LAST_POSITION(state, data) {
      state.routerLastPosition[data.name] = data.scrollPosition;
    },
    REQUEST_YEAR_COMMAND(state, data) {
      state.yearCommande = data;
    },
    REQUEST_LOADED_ARTICLE_IMAGE(state, image) {
      if (image) {
        state.loadedArticleImages[image] = true
      }
    },
  },
  actions: {
    requestRouterLastPosition(context, data) {
      context.commit("REQUEST_ROUTER_LAST_POSITION", data);
    },
    requestYearCommande(context, data) {
      context.commit("REQUEST_YEAR_COMMAND", data);
    },
    requestLoadedArticleImage(context, image) {
      context.commit("REQUEST_LOADED_ARTICLE_IMAGE", image);
    },
  },
  modules: {
  }
})
